const Services = ({ data }) => {
  return (
    <div id="services">
      <div className="w-[98%] hidden lg:flex h-fit mx-auto p-8 rounded-2xl flex-col bg-[#313A44]">
        {data.grid.map((row, index) => (
          <>
            <div key={index} className="relative flex flex-row w-full text-[#C9CED2] hover:text-white min-h-[146px] group">
              {row.index && (
                <span className={`w-[10%] text-[16px] hidden group-hover:flex font-medium text-[${row.index.index_text_hover_color}]`} >{row.index.index_text}</span>
              )}
              {row.index && (
                <span className={`w-[10%] text-[16px] flex group-hover:hidden font-medium text-[${row.index.index_text_main_color}]`} >{row.index.index_text}</span>
              )}
              {row.main && (
                <span className={`w-[40%] text-[28px] font-medium text-[${row.main.main_color}]`}>{row.main.main_text}</span>
              )}
              {row.secondary && (
                <span className={`w-[15%] ml-[15%] text-[16px] text-[${row.main.secondary_color}]`}>{row.secondary.secondary_text}</span>
              )}
              {row.link_button && (
                <div className="p-5 bg-[] flex group-hover:hidden rounded-full ml-auto h-[65px] w-[65px] my-auto border-[1px] border-white">
                  <img src={row.link_button.button_image_url} alt="Button" />
                </div>
              )}

              {row.link_button && (
                <div className="p-5 bg-[#C3372E] hidden group-hover:flex rounded-full ml-auto h-[65px] w-[65px] my-auto">
                  <img src={row.link_button.button_image_url} alt="Button" />
                </div>
              )}

              {/* Картинка, которая будет показываться при ховере */}
              {row.hover_image_url && (
                <img
                  className="absolute h-full left-[64%] z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  src={row.hover_image_url}
                  alt="Hover"
                />
              )}

              {/* Текст, который будет показываться при ховере */}
              {row.secondary && (
                <span className="absolute h-[90%] top-[10%] left-[65%] z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-[15%] text-[16px] font-medium shadow-2xl">
                  {row.secondary.secondary_text}
                </span>
              )}
            </div>

            <hr className="w-full bg-white my-2 opacity-[10%]" />
          </>
        ))}

      </div>





      <div className=" w-[98%] hidden sm:flex lg:hidden h-fit mx-auto p-8 rounded-2xl flex-col bg-[#313A44]">
        {data.grid.map((row, index) => (
          <>
            <div key={index} className="relative flex flex-row w-full text-[#C9CED2] hover:text-white min-h-[146px] group">
              {row.index && (
                <span className={`w-[10%] text-[16px] hidden group-hover:flex font-medium text-[${row.index.index_text_hover_color}]`} >{row.index.index_text}</span>
              )}
              {row.index && (
                <span className={`w-[10%] text-[16px] flex group-hover:hidden font-medium text-[${row.index.index_text_main_color}]`} >{row.index.index_text}</span>
              )}
              <div className="w-[50%] h-full flex flex-col justify-between">

                {row.main && (
                  <span className={`w-full text-[24px] font-medium text-[${row.main.main_color}]`}>{row.main.main_text}</span>
                )}
                {row.secondary && (
                  <span className={`w-full] text-[16px] text-[${row.main.secondary_color}]`}>{row.secondary.secondary_text}</span>
                )}
                {row.link_button && (
                  <div className="p-3 bg-[] flex group-hover:hidden rounded-full h-[47px] w-[47px] my-4 border-[1px] border-white">
                    <img src={row.link_button.button_image_url} alt="Button" />
                  </div>
                )}

                {row.link_button && (
                  <div className="p-3 bg-[#C3372E] hidden group-hover:flex rounded-full h-[47px] w-[47px] my-4">
                    <img src={row.link_button.button_image_url} alt="Button" />
                  </div>
                )}

              </div>


              {row.hover_image_url && (
                <div className="rounded-2xl h w-[40%]" style={{ backgroundImage: `url("${row.hover_image_url}")`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "auto 100%" }}>

                </div>
                // <img
                //   className=""
                //   src={row.hover_image_url}
                //   alt="Hover"
                // />
              )}
            </div>

            <hr className="w-full bg-white my-2 opacity-[10%]" />
          </>
        ))}

      </div>






      <div className="w-[98%] h-fit mx-auto p-4 rounded-2xl flex-col bg-[#313A44] flex sm:hidden">
        {data.grid.map((row, index) => (
          <>
            {row.hover_image_url && (
              <div className="rounded-2xl h-60 w-[100%]" style={{ backgroundImage: `url("${row.hover_image_url}")`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "auto 100%" }}>

              </div>
              // <img
              //   className=""
              //   src={row.hover_image_url}
              //   alt="Hover"
              // />
            )}

            <div key={index} className="relative flex flex-col w-full  text-[#C9CED2] hover:text-white group">


              <div className="w-[100%] h-full mt-4 mb-2 flex flex-row gap-2">
                {row.index && (
                  <span className={`w-[10%] text-[16px] hidden group-hover:flex font-medium text-[${row.index.index_text_hover_color}]`} >{row.index.index_text}</span>
                )}
                {row.index && (
                  <span className={`w-[10%] text-[16px] flex group-hover:hidden font-medium text-[${row.index.index_text_main_color}]`} >{row.index.index_text}</span>
                )}

                {row.secondary && (
                  <span className={`w-full] text-[16px] text-[${row.main.secondary_color}]`}>{row.secondary.secondary_text}</span>
                )}


              </div>

              {row.main && (
                <span className={`w-full text-[24px] font-medium text-[${row.main.main_color}]`}>{row.main.main_text}</span>
              )}


              {row.link_button && (
                <div className="p-3 bg-[] flex group-hover:hidden rounded-full h-[47px] w-[47px] my-4 border-[1px] border-white">
                  <img src={row.link_button.button_image_url} alt="Button" />
                </div>
              )}

              {row.link_button && (
                <div className="p-3 bg-[#C3372E] hidden group-hover:flex rounded-full h-[47px] w-[47px] my-4">
                  <img src={row.link_button.button_image_url} alt="Button" />
                </div>
              )}


            </div>

            <hr className="w-full bg-white my-2 opacity-[10%]" />
          </>
        ))}

      </div>
    </div>
  );
};

export default Services;
